/** Pizza ilustrada en SVG (base para hero, tarjetas sin foto y hoja de producto). */
export default function PizzaArt({ className = '', toppings = true, style }) {
  return (
    <svg viewBox="0 0 200 200" className={className} style={style} aria-hidden="true" focusable="false">
      <circle cx="100" cy="100" r="96" fill="#C98B4E" />
      <circle cx="100" cy="100" r="90" fill="#D9A066" />
      <circle cx="100" cy="100" r="80" fill="#E8B26A" />
      <circle cx="100" cy="100" r="80" fill="none" stroke="#C98545" strokeWidth="3" strokeDasharray="2 9" />
      <circle cx="100" cy="100" r="69" fill="#D9472B" />
      <path
        d="M100 36c18 2 30 8 40 17 9 9 7 18 18 26 7 6 6 18 1 27-4 8-12 10-13 20-1 11-10 18-21 21-10 3-17-3-27 0-10 3-19 8-29 2-9-6-8-15-15-22-7-7-17-10-17-22 0-11 9-16 11-26 2-11-2-20 7-28 9-9 20-8 30-12 5-2 10-4 15-3z"
        fill="#FCD26B"
      />
      <g fill="#FFE39A" opacity="0.7">
        <ellipse cx="80" cy="80" rx="10" ry="5" />
        <ellipse cx="124" cy="120" rx="12" ry="5" />
        <ellipse cx="118" cy="70" rx="7" ry="4" />
      </g>
      <g stroke="#E8B26A" strokeWidth="2.5" opacity="0.9">
        <line x1="100" y1="31" x2="100" y2="169" />
        <line x1="31" y1="100" x2="169" y2="100" />
        <line x1="51" y1="51" x2="149" y2="149" />
        <line x1="149" y1="51" x2="51" y2="149" />
      </g>
      {toppings ? (
        <>
          <g fill="#B3261E">
            <circle cx="78" cy="66" r="10" />
            <circle cx="128" cy="74" r="10" />
            <circle cx="66" cy="114" r="10" />
            <circle cx="118" cy="128" r="10" />
            <circle cx="100" cy="96" r="9" />
            <circle cx="140" cy="112" r="8" />
            <circle cx="88" cy="140" r="8" />
          </g>
          <g fill="#3E8E41">
            <ellipse cx="112" cy="58" rx="7" ry="3.5" transform="rotate(-30 112 58)" />
            <ellipse cx="56" cy="88" rx="7" ry="3.5" transform="rotate(40 56 88)" />
            <ellipse cx="146" cy="138" rx="7" ry="3.5" transform="rotate(-15 146 138)" />
            <ellipse cx="96" cy="118" rx="6" ry="3" transform="rotate(60 96 118)" />
          </g>
        </>
      ) : null}
    </svg>
  );
}

/** Vapor sutil (SVG) que sale de la pizza. */
export function Steam({ className = '' }) {
  return (
    <svg viewBox="0 0 120 80" className={`t-steam ${className}`} aria-hidden="true" focusable="false">
      <g fill="none" stroke="#FFFDF8" strokeWidth="5" strokeLinecap="round">
        <path d="M30 75 C 20 60, 40 50, 30 35 S 30 10, 36 4" />
        <path d="M60 75 C 50 58, 70 48, 60 32 S 60 10, 66 2" />
        <path d="M90 75 C 80 60, 100 50, 90 35 S 90 12, 96 6" />
      </g>
    </svg>
  );
}
